module.exports = __webpack_public_path__ + "static/media/MenuChickenFingers.e2eba2c3.jpg";